import React, { useEffect, useState } from "react";
import { apiRequest } from "../apiService/allapi";
// import "./Events.css";

function Events() {
  const [event, setEvent] = useState([]);
  const [selectedState, setSelectedState] = useState("");
  const [expandedEvent, setExpandedEvent] = useState(null);

  const API_BASE_URL = process.env.REACT_APP_IMAGE_BASE_URL;

  // ================= Toggle Details =================

  const toggleDetails = (id) => {
    setExpandedEvent(expandedEvent === id ? null : id);
  };

  // ================= Get Events =================

  const GetEvents = async () => {
    try {
      const token = localStorage.getItem("token");

      const res = await apiRequest("/AppInfo/getEvent", "GET", null, {
        Authorization: `Bearer ${token}`,
      });

      if (res?.data?.status === "success") {
        setEvent(res.data.data);
      }
    } catch (error) {
      console.log("Event API Error:", error);
    }
  };

  useEffect(() => {
    GetEvents();
  }, []);

  // ================= Unique States =================

  const uniqueStates = [...new Set(event.map((item) => item.stateName))];

  // ================= Filter Events =================

  const filteredEvents = selectedState
    ? event.filter((item) => item.stateName === selectedState)
    : [];

  return (
    <section className="events-section">
      <div className="container">
        {/* ================= Heading ================= */}

        <div className="events-heading">
          <span className="events-subtitle">Upcoming Programs</span>

          <h2>Explore Our Upcoming Events</h2>

          <p>
            Join our latest seminars, business meetings, product launches and
            networking events happening across different cities.
          </p>
        </div>

        {/* ================= Filter ================= */}

        <div className="filter-wrapper">
          <div className="row align-items-center">
            <div className="col-lg-5 col-md-5 mb-3">
              <select
                className="form-control custom-input"
                value={selectedState}
                onChange={(e) => setSelectedState(e.target.value)}
              >
                <option value="">Select State</option>

                {uniqueStates.map((state, index) => (
                  <option key={index} value={state}>
                    {state}
                  </option>
                ))}
              </select>
            </div>

            <div className="col-lg-4 col-md-4 mb-3">
              <div className="total-events">
                Total Events :<span>{filteredEvents.length}</span>
              </div>
            </div>

            <div className="col-lg-3 col-md-3 mb-3">
              <button className="search-btn">Search Event</button>
            </div>
          </div>
        </div>

        {/* ================= Events ================= */}

        <div className="row">
          {filteredEvents.length > 0 ? (
            filteredEvents.map((item) => (
              <div className="col-lg-6 mb-4" key={item.eventId}>
                <div className="event-card">
                  {/* ================= Image ================= */}

                  <div className="event-image">
                    <img
                      src={`${API_BASE_URL}${item.image}`}
                      alt={item.eventTitle}
                    />

                    <div className="event-date-box">
                      <span>{item.adddate.split("/")[1]}</span>

                      <p>{item.adddate.split("/")[0]}</p>
                    </div>
                  </div>

                  {/* ================= Content ================= */}

                  <div className="event-content">
                    <span className="event-category">{item.category}</span>

                    {/* ================= Title Always Show ================= */}

                    <h3>{item.eventTitle}</h3>

                    {/* ================= Show Details On Click ================= */}

                    {expandedEvent === item.eventId && (
                      <>
                        <p className="event-description">{item.description}</p>

                        {/* ================= Info ================= */}

                        <div className="event-info">
                          <div className="info-item">
                            <i className="fa fa-map-marker"></i>

                            <span>
                              {item.address}, {item.cityName}, {item.stateName}
                            </span>
                          </div>

                          <div className="info-item">
                            <i className="fa fa-user-circle"></i>

                            <span>{item.eventPresenter}</span>
                          </div>

                          <div className="info-item">
                            <i className="fa fa-phone"></i>

                            <span>{item.mobileNo}</span>
                          </div>

                          <div className="info-item">
                            <i className="fa fa-calendar-check-o"></i>

                            <span>{item.adddate}</span>
                          </div>

                          <div className="info-item">
                            <i className="fa fa-clock-o"></i>

                            <span>{item.eventTime}</span>
                          </div>
                        </div>
                      </>
                    )}

                    {/* ================= Button ================= */}

                    <button
                      className="details-btn"
                      onClick={() => toggleDetails(item.eventId)}
                    >
                      {expandedEvent === item.eventId
                        ? "Hide Details"
                        : "View Details"}
                    </button>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="no-events">
              <img
                src="https://cdn-icons-png.flaticon.com/512/7486/7486740.png"
                alt=""
              />

              <h4>
                {selectedState ? "No Events Found" : "Please Select State"}
              </h4>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}

export default Events;
